import { render, staticRenderFns } from "./ModalCreateNatureOps.vue?vue&type=template&id=3543db7f&scoped=true"
import script from "./ModalCreateNatureOps.vue?vue&type=script&lang=js"
export * from "./ModalCreateNatureOps.vue?vue&type=script&lang=js"
import style0 from "./ModalCreateNatureOps.vue?vue&type=style&index=0&id=3543db7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3543db7f",
  null
  
)

export default component.exports